export const getProductsVariantsData = `
query getProductsVariants($ids: [ID!]!) {
  nodes(ids:$ids) {
    ... on Product {
      id
      variants(first: 250) {
        nodes {
          id
          availableForSale
          quantityAvailable
          title
          selectedOptions {
            name
            value
          }
        }
      }
    }
  }
}
`
